module.exports = __webpack_public_path__ + "static/media/loading.edcb3e91.png";